<div class="dice-container">
  <div class="dice-wrapper transition-transform" [style.scale]="isPresenting() ? 1.3 : 1">
    <div
      class="dice"
      [style]="{ transform: 'translateZ(calc(var(--wh) / 2)) rotateX(' + target().x + 'deg) rotateY(' + target().y + 'deg)' }"
    >
      <rid-dice-face class="front"><ng-content select="[face='1']" /></rid-dice-face>
      <rid-dice-face class="top"><ng-content select="[face='2']" /></rid-dice-face>
      <rid-dice-face class="left"><ng-content select="[face='3']" /></rid-dice-face>
      <rid-dice-face class="right"><ng-content select="[face='4']" /></rid-dice-face>
      <rid-dice-face class="bottom"><ng-content select="[face='5']" /></rid-dice-face>
      <rid-dice-face class="back"><ng-content select="[face='6']" /></rid-dice-face>
    </div>
  </div>
</div>
